import { Icon } from '@chakra-ui/react';
import { MdPerson, MdHome, MdLock, MdOutlineShoppingCart, MdMiscellaneousServices } from 'react-icons/md';
import { FaUser, FaUsers } from "react-icons/fa";

// Admin Imports
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';

// Auth Imports
import SignInCentered from 'views/auth/signIn';

import MapContainer from 'views/admin/clients';
import InfoCliente from 'views/admin/infoCliente';
import VendasPage from 'views/admin/vendas';
import ServicePage from 'views/admin/servicos';
import ClientsInactive from 'views/admin/clients_inacive';

const routes = [
	{
		name: 'Dashboard',
		layout: '/admin',
		path: '/default',
		visible: true,
		icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
		component: MainDashboard
	},
	{
		name: 'Clientes',
		layout: '/admin',
		path: '/clients',
		visible: true,
		icon: <Icon as={FaUsers} width='20px' height='20px' color='inherit' />,
		component: MapContainer,
	},
	{
		name: 'Vendas',
		layout: '/admin',
		path: '/vendas',
		visible: localStorage.getItem('master') === 'true',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: VendasPage
		
	},
	{
		name: 'Informações do Cliente',
		layout: '/admin',
		path: '/clientInfo',
		visible: false,
		icon: <Icon as={FaUser} width='20px' height='20px' color='inherit' />,
		component: InfoCliente,
	},
	{
		name: 'Perfil',
		layout: '/admin',
		path: '/profile',
		visible: false,
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: Profile
		
	},
	{
		name: 'Serviços',
		layout: '/admin',
		path: '/services',
		visible: true,
		icon: <Icon as={MdMiscellaneousServices } width='20px' height='20px' color='inherit' />,
		component: ServicePage
	},
	{
		name: 'Clientes Inativos',
		layout: '/admin',
		path: '/inactive_clientes',
		visible: localStorage.getItem('master') === 'true',
		icon: <Icon as={FaUsers} width='20px' height='20px' color='inherit' />,
		component: ClientsInactive
	},
	{
		name: 'Sign In',
		layout: '/auth',
		path: '/sign-in',
		visible: false,
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: SignInCentered
	},
];

export default routes;
